module.exports = __webpack_public_path__ + "img/kv-left.c1edc4ed.jpg";